

import { NgModule } from '@angular/core';
import { TnxSharedModule } from 'tnx-shared';
import { LogSubscribeFormComponent } from './logsubscribe-form/logsubscribe-form.component';
import { LogSubscribeComponent } from './logsubscribe.component';
import { LogSubscribeRoutes } from './logsubscribe.routing';

export function declaration() {
    return [LogSubscribeComponent, LogSubscribeFormComponent];
}

@NgModule({
    imports: [
        TnxSharedModule
    ],
    declarations: declaration(),
    exports: declaration()
})
export class LogSubscribeModule {
}

@NgModule({
    imports: [LogSubscribeModule, LogSubscribeRoutes],
    exports: [LogSubscribeModule]
})
export class LogSubscribeWithRouteModule {
}
